import { UpdateTPMQueryMsg, UpdateTPMQueryQuery } from '../../autogenerated/ZoomBridge';

export default class ClientUpdateTPMQuery {
  constructor(path) {
    this.path = path;
  }

  run() {
    return new Promise((onSuccess, onFailure) => {
      const query = new UpdateTPMQueryQuery();
      query.message = new UpdateTPMQueryMsg();
      query.message.setPath(this.path);
      query.run().then(
        (resp) => {
          onSuccess(resp);
        },
        (failedResp) => {
          onFailure(failedResp);
        }
      );
    });
  }
}
